import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { TabService } from '@app/services/tab.service';
import { TabButtonComponent } from '@app/chat/components/tab-button/tab-button.component';

@Component({
  selector: 'app-active-tab',
  imports: [CommonModule, RouterLink, TabButtonComponent],
  styles: `
    :host {
      @apply px-2 text-white;
    }
  `,
  template: `
    @if (tabService.activeTab()) {
      <app-tab-button
        [tab]="tabService.activeTab()"
        [hideCloseButton]="true"
        [darkMode]="true"
        contentClass="text-white text-center"
        class="m-auto max-w-full truncate" />
    } @else {
      <a routerLink="chat" class="block pb-2 pr-8 text-center text-3xl text-white" [ngClass]="{ 'pl-6': authService.currentUser() }">
        <span class="icon-qira-logo text-3xl"></span>
      </a>
    }
  `,
})
export class ActiveTabDisplayComponent {
  authService = inject(AuthService);
  tabService = inject(TabService);
}
